import { Stack, StackProps, Typography } from '@mui/material'
import { Markdown } from '@cibo/ui'

export interface SectionHeaderProps extends StackProps {
  title: string
  subtitle?: string
}
export const SectionHeader = ({ title, subtitle, ...stackProps }: SectionHeaderProps) => (
  <Stack {...stackProps}>
    <Typography variant="h6">{title}</Typography>
    {!!subtitle && <Markdown typographyProps={{ variant: 'caption' }}>{subtitle}</Markdown>}
  </Stack>
)
